import { RouteProps } from '../../routes/AppRouter'
import { ProtocolDetail } from '../../features/protocols'
import React from 'react'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function ProtocolDetailPage(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return <ProtocolDetail id={props.id} />
}
